import { render, staticRenderFns } from "./DashboardDriverDistribution.vue?vue&type=template&id=0f2c715c&scoped=true"
import script from "./DashboardDriverDistribution.vue?vue&type=script&lang=js"
export * from "./DashboardDriverDistribution.vue?vue&type=script&lang=js"
import style0 from "./DashboardDriverDistribution.vue?vue&type=style&index=0&id=0f2c715c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2c715c",
  null
  
)

export default component.exports